var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-container',{staticClass:"gp-has-header"},[_c('h5',[_c('mdb-spinner'),_vm._v("Logging You Out")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }